export const excursionCount = {
  found_pluralized: ['найдена', 'найдено', 'найдено'],
  items: 'экскурсии',
  items_pluralized: ['экскурсия', 'экскурсии', 'экскурсий'],
};

export const toursCount = {
  found_pluralized: ['найден', 'найдено', 'найдено'],
  items: 'туры',
  items_pluralized: ['тур', 'тура', 'туров'],
};

export const reviewsCountLabel = {
  items: 'отзывы',
  items_pluralized: ['отзыв', 'отзыва', 'отзывов'],
};

export const travelersCount = {
  items: 'путешественники',
  items_pluralized: ['путешественник', 'путешественников', 'путешественников'],
};

export const SKELETON_APPEARANCE_DELAY = 300;
export const SKELETON_MIN_VISIBLE_DURATION = 500;
